/**
 * Polyfills from intl
 */
export const loadIntlPolyfill = () => import('intl' /* webpackChunkName: "polyfill-intl" */);

/**
 * Polyfills for @formatjs
 */

export const loadIntlCanonicalLocalesPolyfill = () =>
  import(
    '@formatjs/intl-getcanonicallocales/polyfill' /* webpackChunkName: "polyfill-intl-getcanonicallocales" */
  );

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
export const loadIntlDateTimeFormatPolyfill = () =>
  import(
    '@formatjs/intl-datetimeformat/polyfill' /* webpackChunkName: "polyfill-intl-datetimeformat" */
  );

export const loadIntlDateTimeFormatTimezone = () =>
  import(
    '@formatjs/intl-datetimeformat/add-all-tz' /* webpackChunkName: "polyfill-intl-datetimeformat-add-all-tz" */
  );

export const loadIntlDisplayNamesPolyfill = () =>
  import(
    '@formatjs/intl-displaynames/polyfill' /* webpackChunkName: "polyfill-intl-displaynames" */
  );

export const loadIntlNumberFormatPolyfill = () =>
  import(
    '@formatjs/intl-numberformat/polyfill' /* webpackChunkName: "polyfill-intl-numberformat" */
  );

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/PluralRules
// https://caniuse.com/#feat=intl-pluralrules
// IE/Safari
export const loadIntlPluralRulesPolyfill = () =>
  import('@formatjs/intl-pluralrules/polyfill' /* webpackChunkName: "polyfill-intl-pluralrules" */);

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RelativeTimeFormat
export const loadIntlRelativeTimeFormatPolyfill = () =>
  import(
    '@formatjs/intl-relativetimeformat/polyfill' /* webpackChunkName: "polyfill-intl-relativetimeformat" */
  );

export const loadIntlListFormatPolyfill = () =>
  import('@formatjs/intl-listformat/polyfill' /* webpackChunkName: "polyfill-intl-listformat" */);

export const loadIntlLocalePolyfill = () =>
  import('@formatjs/intl-locale/polyfill' /* webpackChunkName: "polyfill-intl-locale" */);
